import { render, staticRenderFns } from "./FormCalonPelanggan.vue?vue&type=template&id=c355de96"
import script from "./FormCalonPelanggan.vue?vue&type=script&lang=js"
export * from "./FormCalonPelanggan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports